import { PublicOutlinedIcon } from '@occc/ui-design-system';
import { Switches } from '@occc-app/design-system';

import { GLOBAL_AWARD_COUNT_LIMITS_PATH } from './fulfillment-limits.constants';

import type {
  AwardCountLimitPeriodOption,
  AwardCountLimitTimePeriod,
} from '../../award-count-limit';
import { StackedLimitRows } from '../stacked-limit-rows';
import { LimitFormContent } from '../limit-form-content';
import { LimitFormContentLayout } from '../limit-form-content-layout';
import { LimitComponentProps } from '../../types';

type GlobalFulfillmentLimitProps = LimitComponentProps & {
  stacked?: boolean;
  periodOptions?: AwardCountLimitPeriodOption[];
  defaultPeriod?: AwardCountLimitTimePeriod;
};

export const GlobalFulfillmentLimit = ({
  open,
  title,
  description,
  limitLabel,
  showAvatar = false,
  stacked = false,
  periodOptions,
  defaultPeriod,
}: GlobalFulfillmentLimitProps) =>
  stacked ? (
    <StackedLimitRows
      formNamePath={GLOBAL_AWARD_COUNT_LIMITS_PATH}
      open={open}
      title={title || 'Global Fulfillment Limits'}
      description={description ?? 'Global Fulfillment Limits'}
      limitLabel={limitLabel}
      avatar={showAvatar ? PublicOutlinedIcon : undefined}
      periodOptions={periodOptions}
      defaultPeriod={defaultPeriod}
    />
  ) : (
    <LimitFormContentLayout
      title={title || 'Global Fulfillment Limit'}
      description={description ?? 'Global Fulfillment Limit'}
      action={<Switches name='awardCount.global.isEnabled' data={{}} />}
      open={open}
      avatar={showAvatar ? PublicOutlinedIcon : undefined}
    >
      <LimitFormContent name='awardCount.global' limitLabel={limitLabel} />
    </LimitFormContentLayout>
  );
